import Immutable from 'seamless-immutable'
import {REHYDRATE} from 'redux-persist/constants'
import * as notifyActions from '../actions/notify'

const initialState = Immutable({
	pushNotificationRegistered: false,
	afterLoginPushData: false,
	history: [],
	lastAddedHistoryAmount: undefined
})

export default function (state = initialState, action){
	switch(action.type){
		case REHYDRATE:
			if(action.payload.Notify){
				return state.merge({
					pushNotificationRegistered: action.payload.Notify.pushNotificationRegistered === undefined ? false : action.payload.Notify.pushNotificationRegistered,
				})
			}
			return state

		case notifyActions.NOTIFY_REGISTER_PUSH_NOTIFICATION:
			return state.merge({pushNotificationRegistered: action.registered})

		case notifyActions.NOTIFY_PROCESS_PUSH_NOTIFICATION_AFTER_LOGIN:
			return state.set('afterLoginPushData', action.notification)

		case notifyActions.NOTIFY_UPDATE_HISTORY:
			const newState = state.set('lastAddedHistoryAmount', action.history.length)
			return !action.append ? newState.set('history', action.history) : newState.update('history', (history) => history.concat(action.history))

	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/notify.js